import { render, staticRenderFns } from "./DailyGoal.vue?vue&type=template&id=15fda6c1"
import script from "./DailyGoal.vue?vue&type=script&lang=js"
export * from "./DailyGoal.vue?vue&type=script&lang=js"
import style0 from "./DailyGoal.vue?vue&type=style&index=0&id=15fda6c1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports